import { lazyComponent } from '@/helpers/lazy-component.helper';

export enum MyAccountSection {
  UPCOMING = 'MyAccount',
  HISTORY = 'MyAccountHistory',
  INVOICES = 'MyAccountInvoices',
  VOUCHERS = 'MyAccountVouchers',
}

export const DEFAULT_MY_ACCOUNT_SECTION = MyAccountSection.UPCOMING;

export const MY_ACCOUNT_SECTIONS = [
  {
    routeName: MyAccountSection.UPCOMING,
    path: '',
    labelKey: 'myAccount.sections.upcoming',
    component: lazyComponent(
      () => import('@/components/customers/view/CustomerOpenBookings.vue'),
    ),
  },
  {
    routeName: MyAccountSection.HISTORY,
    path: 'history',
    labelKey: 'myAccount.sections.history',
    component: lazyComponent(
      () => import('@/components/customers/view/CustomerClosedBookings.vue'),
    ),
  },
  {
    routeName: MyAccountSection.INVOICES,
    path: 'invoices',
    labelKey: 'myAccount.sections.invoices',
    component: lazyComponent(
      () => import('@/components/customers/view/CustomerInvoices.vue'),
    ),
  },
  {
    routeName: MyAccountSection.VOUCHERS,
    path: 'vouchers',
    labelKey: 'myAccount.sections.vouchers',
    component: lazyComponent(
      () => import('@/components/customers/view/CustomerFidelityVouchers.vue'),
    ),
  },
];
